import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './clinicalTrial.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class ClinicalTrialDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.clinicalTrial.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'clinicalTrial_' + this.props.clinicalTrial.trialName}>
        <div className="col-md-4 primary-data">
          {
            this.props.clinicalTrial.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.clinicalTrial.trialName}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.trialId} />}
                value={this.props.clinicalTrial.trialId} language={this.props.language}
                isActive={this.configurationActive('TrialId')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.trialDescription} />}
                value={this.props.clinicalTrial.trialDescription} language={this.props.language}
                isActive={this.configurationActive('TrialDescription')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.clinicalTrial.startDate} language={this.props.language} isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.endDate} />}
                value={this.props.clinicalTrial.endDate} language={this.props.language} isDate
                isActive={this.configurationActive('EndDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.clinicalTrial.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.clinicalTrial.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.clinicalTrial.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.clinicalTrial.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.clinicalTrial.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="clinicalTrial_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.clinicalTrial.nullMessage}
        </div>
      </div>
    );
  }
}

ClinicalTrialDetail.propTypes = {
  clinicalTrial: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
